import Vue from 'vue'
import store from '@/store'
let ExamineProblemDlgConstructor = Vue.extend(require('./main.vue'))

let instance

var examineProblemDlg = function (options) {
  options = options || {}
  if (!instance) {
    instance = new ExamineProblemDlgConstructor({
      data: options,
      store: store
    })
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
  }

  // instance.vm.loadData()
  instance.vm.dshid = options.dshid
  instance.vm.isEditData = options.isEditData
  instance.vm.guid = options.guid
  instance.vm.show = true
  return instance.vm
}

export default examineProblemDlg



// WEBPACK FOOTER //
// ./src/components/examineProblemDlg/src/main.js